__turbopack_context__.v({
  "dropzone": "CollateralEditor-module-scss-module__pAaMnq__dropzone",
  "dropzoneInner": "CollateralEditor-module-scss-module__pAaMnq__dropzoneInner",
  "fileType": "CollateralEditor-module-scss-module__pAaMnq__fileType",
  "option": "CollateralEditor-module-scss-module__pAaMnq__option",
  "optionIcon": "CollateralEditor-module-scss-module__pAaMnq__optionIcon",
});
